var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-messenger-loading-skeletons"},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"bc-messenger-loading-skeleton bcx-skeleton-areas"},[_c('div',{staticClass:"c-avatar"}),_c('div'),_c('div'),_c('div',{staticClass:"c-indicator"}),_c('div',{staticClass:"c-line-2"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }